module.exports = __webpack_public_path__ + "img/m-ask.21dd8395.png";